<template>
  <div>
    <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="goBack"
      ></el-button>
    <div
      style="
          width: 100%;
          text-align: center;
          font-size: 25px;
          font-weight: bold;
        "
    >门禁授权申请</div>
    <div style="justify-content: center">
      <div
        style="
            margin-top: 30px;
            justify-content: center;
            margin-left: 5%;
            margin-right: 5%;
          "
      >
        <el-row justify="center" align="middle" style>
          <el-col :span="2">
            <div class="trcol">预约人</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusername }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">学号/工号</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserid }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">院系/部门</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserdepartname }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <div class="trcol">专业</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusermajor != null ? userInfo.amusermajor : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">班级</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amuserclass != null ? userInfo.amuserclass : " " }}</div>
          </el-col>
          <el-col :span="2">
            <div class="trcol">手机号码</div>
          </el-col>
          <el-col :span="6">
            <div class="tdcol">{{ userInfo.amusertel }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="130px"    v-loading="loading">
          <el-row>
            <el-col :span="24">
              <el-form-item label="申请原因：" prop="applycause">
                <el-input v-model="form.applycause" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="联系电话：" prop="applyusertel">
                    <el-input v-model="form.applyusertel"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车牌号码：" prop="applyplatenumber">
                    <el-input v-model="form.applyplatenumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="所属门禁：" prop="enterschoolgate">
                    <el-select
                      v-model="form.enterschoolgate"
                      clearable
                      filterable
                      placeholder="请选择具体校门"
                      style="width: 100%"
                      @change="changeDept"
                    >
                      <el-option
                        v-for="item in depart"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号：" prop="idcode">
                    <el-input v-model="form.idcode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注说明：" prop="memo">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入具体情况描述"
                  v-model="form.memo"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传头部照片：" prop="pics">
                <el-row>
                  <el-upload
                    ref="upload"
                    :action="uploadPath"
                    :before-upload="beforeAvatarUpload"
                    :data="uploadSettings"
                    :headers="headers"
                    list-type="picture-card"
                    name="Fdata"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                    :limit="2"
                    :on-exceed="overfilenumber"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog append-to-body title="图片详情" :visible.sync="dialogVisible">
                    <img alt :src="dialogImageUrl" width="100%" />
                  </el-dialog>
                </el-row>
                <!-- <el-row>
                  <el-upload
                    ref="upload"
                    :action="uploadPath"
                    :before-upload="beforeAvatarUpload"
                    :data="uploadSettings"
                    :headers="headers"
                    list-type="picture-card"
                    name="Fdata"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog append-to-body title="图片详情" :visible.sync="dialogVisible">
                    <img alt :src="dialogImageUrl" width="100%" />
                  </el-dialog>
                </el-row>-->
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item style="align-items: center; text-align: center">
                <el-button class="submitClass" @click="onSubmit('form')">提交</el-button>
                <el-button class="colseClass" @click="goBack">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
  
<script>
// import moment from 'moment'
import { Message } from "element-ui";
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import { getSysDict, addApplyAuthorization } from "@/api/accessAuthorization";
//
import { sendMsg } from "@/api/serviceInfo.js";
import {
  queryMatter,
  queryRunById,
} from "@/api/matter.js";
import moment from "moment";
export default {
  name: "accessAuthorization",
  data() {
    return {
      loading:false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      recepuseriddisabled: true,
      depart: [],
      recepuserlist: [],
      userInfo: {
        amuserid: "",
        amusername: "",
        amusertel: "",
        amuserdepartcode: "",
        amuserdepartname: "",
        amusermajor: "",
        amusergrade: "",
        amuserclass: ""
      },
      form: {
        // id: "",
        applycause: "",
        applyplatenumber: "",
        enterschoolgate: "",
        idcode: "",
        applyusertel: "",
        memo: "",
        pics: "",
        handlestate: 1
      },
      rules: {
        applycause: [
          { required: true, message: "请申请原因", trigger: "blur" }
        ],
        applyplatenumber: [
          { required: true, message: "请输入车牌号码", trigger: "blur" }
        ],
        enterschoolgate: [
          { required: true, message: "请选择进入校门", trigger: "blur" }
        ],
        idcode: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        applyusertel: [
          { required: true, message: "请输入联系人电话", trigger: "blur" }
        ]
      },
      colStyWidth: "0px",
      types: [],
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      uploadSettings: {
        uploadUrl: "",
        packageName: "/img",
        templateUrl: " ",
        queueLimit: 10,
        fileTypes: ["*"],
        limitSize: 2
      },
      headers: {
        appkey: "XKES"
      },
      centerArr: [],
      srcList: [],
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      width: "60", // 设置视频播放器的显示宽度（以像素为单位）
      height: "60", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: ""
    };
  },
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(user);
    this.userInfo = {
      amuserid: user.userid,
      amusername: user.name,
      amusertel: user.mobile,
      amuserdepartcode: "",
      amuserdepartname: user.department,
      amusermajor: user.major,
      amusergrade: user.grade,
      amuserclass: user.bj
    };
    console.log(this.userInfo);
    this.getDept();
  },
  methods: {
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let type = file.name.split(".");
      let length = type.length;
      console.log(length)
      console.log(type[length-1]);
      if (
        type[length-1] !== "jpg" &&
        type[length-1] !== "png" &&
        type[length-1] !== "gif" &&
        type[length-1] !== "bmp" &&
        type[length-1] !== "jpeg"
      ) {
        Message({
          message: "仅支持上传jpg、png、gif、bmp、jpeg图片格式！",
          type: "warning"
        });
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        Message({
          message: "文件大小不能超过 10MB!",
          type: "warning"
        });
        return false;
      }
    },
    handleAvatarSuccess(res) {
      console.log(res);
      this.srcList.push(this.fileAcquisition + res.object.url);
      this.centerArr.push({
        name: res.object.originalName,
        type: res.object.type,
        originalUrl: res.object.url,
        url: this.fileAcquisition + res.object.url
      });
      this.form.pics = this.centerArr;
      console.log(this.centerArr);
    },
    // 删除文件
    handleRemove(file) {
      let indexa = "";
      this.centerArr.forEach((item, index) => {
        if (item.url == this.fileAcquisition + file.response.object.url) {
          indexa = index;
        }
      });
      this.centerArr.splice(indexa, 1);
      this.form.pics = this.centerArr;
      console.log(this.form.pics);
    },
    async changeDept() {
      console.log(this.form.enterschoolgate);
      this.recepuseriddisabled = false;
    },
    onSubmit(form) {
      var that = this;
      this.$refs[form].validate(async valid => {
        if (valid) {
          this.form.pics = JSON.stringify(this.form.pics);
          let applicationtime = new Date();
          var formdata = {
            ...this.form,
            ...this.userInfo,
            applicationtime
          };
          console.log("formdata===", formdata);
          this.loading = true;
          const data = await addApplyAuthorization(formdata);
          //const data = "";
          console.log(data);
          if (data.msgCode == 0) {
            let params = {
              id: data.data.id+'-2', //事项id
              receiveUser: data.data.amuserid, //接收者userId
              memo:
                "您在" +
                moment(data.data.createtime).format("YYYY年MM月DD日HH点mm分") +
                "申请了【门禁授权申请】，系统正在办理中，请耐心等待！", //消息内容
              sendUser: data.data.amuserid, //发送者userId
              serviceId: "1575693429255712770", //服务id
              f4:'门禁授权申请'
            };
            console.log(params);
            sendMsg(params).then((res) => {
              console.log(res);
            });
            await queryRunById(data.data.f1).then((res1) => {
              queryMatter(res1.data.f4).then((res2) => {
                if (res2.code == 0) {
                  let params1 = {
                    id: data.data.id+'-1', //事项id
                    receiveUser: res2.data[0].assigneeUser.id, //接收者userId
                    memo: "您收到一个【门禁授权申请】的待处理事项，请及时处理！", //消息内容
                    sendUser: data.data.amuserid, //发送者userId
                    serviceId: "1575693429255712770", //服务id
                    f4:'门禁授权申请'
                  };
                  console.log(params);
                  sendMsg(params1).then((res) => {
                    console.log(res);
                  });
                }
              });
            });
            this.$confirm(
              "您的预约已成功提交，我们会尽快受理您的预约，请及时查询微信消息通知关注预约处理进度，如有其他疑问请拨打该咨询电话：027-0999199231",
              "系统提示",
              {
                confirmButtonText: "返回主页",
                cancelButtonText: "继续预约",
                type: "success",
                center: true,
                showClose: false,
                callback: (action, instance) => {
                   this.loading = false;
                  console.log(action);
                  console.log(instance);
                  // 返回主页
                  if (action == "confirm") {
                    that.$router.push("/serviceHome");
                  }
                  // 继续反馈
                  if (action == "cancel") {
                    this.centerArr = [];
                    this.$refs["form"].resetFields();
                    this.$refs["upload"].clearFiles();
                  }
                },
                closeOnClickModal: false,
                closeOnPressEscape: false,
                cancelButtonClass: "cancelButtonClass",
                confirmButtonClass: "confirmButtonClass"
              }
            )
              .then(() => {
                that.from = {
                  id: "",
                  applydepname: "",
                  applyusers: "",
                  memo: "",
                  pics: "",
                  handlestate: 1
                };
                console.log(that.form);
               
              })
              .catch(() => {});
          }
        }
      });
    },
    overfilenumber() {
      Message({
        message: "上传图片不能超过两张",
        type: "warning"
      });
    },
    getDept() {
      getSysDict("SCHOOLGATE").then(res => {
        let d = [];
        if (res.data !== null) {
          res.data.map(item => {
            let dict = {
              value: item.dictcode,
              label: item.dictname
            };
            d.push(dict);
          });
        }
        this.depart = d;
        console.log("this.depart====", this.depart);
      });
    },
    goBack() {
      this.$router.push("/serviceHome");
    }
  }
};
</script>
  
<style scoped>
.trcol {
  background-color: #d8efbf;
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.tdcol {
  border: 1px solid #a0cc97;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 100px;
  height: 88px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

.close {
  position: absolute;
  right: 0;
  font-size: 20px;
}

.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: white;
}

.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
  background-color: #008a2c;
}

.el-message-box {
  border: 2px solid #008a2c;
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.el-message-box--center .el-message-box__header {
  padding-top: 15px;
}

.colseClass {
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.colseClass:hover,
.colseClass:focus {
  /* padding: 9px 15px; */
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}

.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.cancelButtonClass {
  padding: 9px 15px;
  font-size: 12px;
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}

.cancelButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.confirmButtonClass,
.confirmButtonClass:focus {
  padding: 9px 15px;
  font-size: 12px;
  color: black;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}

.confirmButtonClass:hover {
  padding: 9px 15px;
  font-size: 12px;
  background: #d9d9d9;
  border-color: #d9d9d9;
  color: black;
}
</style>